import React, { useContext } from 'react';
import { useStoreId, ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';

const useRelatedSearchData = ({
  itemId, navParam, storeId: resolvedStoreId, searchDataProps, keyword = null, propsKeywordOrStoreId
}) => {
  const storeId = useStoreId();
  const { customContext } = useContext(ExperienceContext);
  const variables = customContext?.variables || {};
  const fallbackStoreId = resolvedStoreId || storeId;
  const propsData = searchDataProps?.searchModel?.relatedResults?.relatedKeywords;
  const hasPropsData = propsData && propsData.length > 0;

  // Determine which model to use and whether to skip
  // If keyword exists, it's a search page - use searchModel
  const shouldUseSearchModel = !hasPropsData && keyword;
  const shouldUseRelatedSearchModel = !hasPropsData && (navParam || itemId);
  const shouldSkip = hasPropsData || (!shouldUseSearchModel && !shouldUseRelatedSearchModel);

  // Choose model and variables based on the situation
  const modelName = shouldUseSearchModel ? 'searchModel' : 'relatedSearchModel';
  const searchModelVars = propsKeywordOrStoreId ? { keyword, storeId: fallbackStoreId } : variables;
  const modelVariables = shouldUseSearchModel
    ? searchModelVars
    : { ...(itemId && { itemId }), ...(navParam && { navParam }), storeId: fallbackStoreId };

  const { data, error, loading } = useDataModel(modelName, {
    variables: modelVariables,
    skip: shouldSkip,
  });

  // Extract data from the appropriate model response
  const dataFromApi = shouldUseSearchModel
    ? data?.searchModel?.relatedResults?.relatedKeywords || []
    : data?.relatedSearchModel?.relatedSearch || [];

  const relatedKeywords = hasPropsData ? propsData : dataFromApi;

  return { relatedKeywords, loading, error };
};

export { useRelatedSearchData };
